import { MprcButtonDropdownChecked } from "components/MprcButtonDropdownChecked";
import { MprcSelectPeriod } from "components/MprcSelectPeriod";
import { KnowledgeSearchPeriod } from "generated/CoreApi_v1";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    selectedOption: any;
    customStartDate: Date | null;
    customEndDate: Date | null;
    onChange: (selected: any, customStartDate: Date | null, customEndDate: Date | null) => void;
}

export const ChooseKnowledgePeriod = ({ selectedOption, customStartDate, customEndDate, onChange }: IProps) => {
    const [dialog, setDialog] = useState<any>(null);
    const { t } = useTranslation("shared");

    ///
    const getCustomDate = () => {
        setDialog(
            <MprcSelectPeriod
                startDate={customStartDate}
                endDate={customEndDate}
                onClose={
                    (period) => {
                        if (period) {
                            onChange(KnowledgeSearchPeriod.Custom, period.start, period.end);
                        }
                        setDialog(null);
                    }
                }
            />
        );
    };

    return (
        <>
            {dialog}

            <MprcButtonDropdownChecked
                title={t("GlobalSearch.Filters.Knowledge.PeriodOption")}
                selected={selectedOption}
                onChange={
                    (selected) => {
                        if (selected == KnowledgeSearchPeriod.Custom) getCustomDate();
                        else onChange(selected, null, null);
                    }
                }
                items={
                    [
                        { text: t("GlobalSearch.Filters.Knowledge.Period.Any"), value: null },
                        { text: t("GlobalSearch.Filters.Knowledge.Period.Last24Hours"), value: KnowledgeSearchPeriod.Last24Hours },
                        { text: t("GlobalSearch.Filters.Knowledge.Period.LastWeek"), value: KnowledgeSearchPeriod.LastWeek },
                        { text: t("GlobalSearch.Filters.Knowledge.Period.LastMonth"), value: KnowledgeSearchPeriod.LastMonth },
                        { text: t("GlobalSearch.Filters.Knowledge.Period.LastYear"), value: KnowledgeSearchPeriod.LastYear },
                        { text: t("GlobalSearch.Filters.Knowledge.Period.OverYear"), value: KnowledgeSearchPeriod.OverYear },
                        { text: t("GlobalSearch.Filters.Knowledge.Period.Custom"), value: KnowledgeSearchPeriod.Custom }
                    ]
                }
            />
        </>
    );
};
